/**
 * Fonction pour gérer la sauvegarde d'un nœud
 */
export const createHandleSaveNode = (
  saveCallFlowToDatabase,
  previousCallFlowDataRef,
  setCallFlowData,
  handleClosePanel
) => {
  return (nodeId, updatedCallFlowData) => {
    saveCallFlowToDatabase(updatedCallFlowData)
      .then((result) => {
        if (result) {
          // Réinitialiser la référence pour forcer la régénération du diagram
          previousCallFlowDataRef.current = null;
          setCallFlowData(updatedCallFlowData);
        }
      })
      .catch((error) => {
        console.error('❌ Erreur lors de la sauvegarde:', error);
      })
      .finally(() => {
        handleClosePanel();
      });
  };
};
